import { render, staticRenderFns } from "./WaiBuGongShi5.vue?vue&type=template&id=46a0140c&scoped=true&"
import script from "./WaiBuGongShi5.vue?vue&type=script&lang=js&"
export * from "./WaiBuGongShi5.vue?vue&type=script&lang=js&"
import style0 from "./WaiBuGongShi5.vue?vue&type=style&index=0&id=46a0140c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0140c",
  null
  
)

export default component.exports